// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event Property Definition: https://pap.pp.dropbox.com/#/event_property/591

import type { FileType } from "../enums/file_type";

const FileTypeValues: FileType[] = [
    "docx",
    "pdf",
    "xls",
    "jpg",
    "png",
    "heic",
    "mp4",
    "mov",
    "txt",
    "mp3",
    "m4a",
    "webp",
    "xlsx",
    "pages",
    "zip",
    "gif",
    "url",
    "numbers",
    "wav",
    "epub",
    "dng",
    "opus",
    "cr2",
    "arw",
    "pptx",
    "psd",
    "doc",
    "amr",
    "csv",
    "clip",
    "nef",
    "kdbx",
    "tiff",
    "svg",
    "apk",
    "key",
    "gpx",
    "aac",
    "procreate",
    "webm",
    "torrent",
    "ipv",
    "cr3",
    "html",
    "xml",
    "vcf",
    "rar",
    "pvt",
    "odt",
    "md",
    "web",
    "gslides",
    "gdoc",
    "gsheet",
    "binder",
    "papert",
    "paper",
    "website",
    "jpeg",
    "json",
    "dwg",
    "indd",
    "ai",
    "tif",
];

export function getFileTypeFromString(s: string): FileType | undefined {
    return FileTypeValues.find(e => e === s?.toLowerCase());
}
